// Returns true if the chart type has axes in the style of a column chart.
export function isVerticalType(type) {
  return type === 'line' ||
    type === 'column' ||
    type === 'area' || 
    type === 'scatter';
}


// Convenience utility function for looping through the ticks on an axis,
// which is necessary a million times in this module.
export function forAxisTicks(axis, callback) {
  for (let i = 0; i < axis.tickPositions.length; i++) {
    let tick = axis.ticks[axis.tickPositions[i]];
    if (callback(tick, axis.tickPositions[i], i) === false) {
      break;
    }
  }
}



// Like forAxisTicks() but runs in reverse (index high to low).
export function forAxisTicksReverse(axis, callback) {
  for (let i = axis.tickPositions.length - 1; i >= 0; i--) {
    let tick = axis.ticks[axis.tickPositions[i]];
    if (callback(tick, axis.tickPositions[i], i) === false) {
      break;
    }
  }
}

export function dashStylesHelper(path, size){
  const dashArray = path.getAttribute('stroke-dasharray');
  if (dashArray !== 'none') {
    const [width, gap] = size === 'print-wsj' ? [1.5, 3] : [2.5, 5];
    path.setAttribute('stroke-width', width);
    path.setAttribute('stroke-dasharray', `0.1,${gap}`);
    path.setAttribute('stroke-linecap', 'round');
  }
}

export function roundLineJoinsHelper(path, isVideoGroup){
  const linejoin = isVideoGroup ? 'round' : 'bevel';
  path.setAttribute('stroke-linejoin', linejoin);
  if (isVideoGroup) {
    path.setAttribute('stroke-linecap', 'round');
  }
}


// WEBPACK FOOTER //
// ./src/chart/inner/util.js